import { Button } from "primereact/button";
import "./ButtonAction.css";

const ButtomAction = (props: any) => {
  return (
    <>
      {props.disabled ? (
        <Button
          label={props.label}
          className={
            (props.isOutline ? "p-button-outlined " : "") +
            "p-button-warning button-fitprenda-common font-fitprenda-button w-100 h-100"
          }
          onClick={props.eventClick}
          disabled
        />
      ) : (
        <Button
          label={props.label}
          className={
            (props.isOutline ? "p-button-outlined " : "") +
            "p-button-warning button-fitprenda-common font-fitprenda-button w-100 h-100"
          }
          onClick={props.eventClick}
        />
      )}
    </>
  );
};

export default ButtomAction;
